import React from 'react';
import { User, Target, Lightbulb, TrendingUp } from 'lucide-react';
import { aboutContent } from '../data/mock';
import { Card, CardContent } from './ui/card';

const About = () => {
  const highlights = [
    {
      icon: User,
      title: 'Who I Am',
      description: 'A passionate student dedicated to mastering software engineering'
    },
    {
      icon: Target,
      title: 'My Focus',
      description: 'Building practical solutions with clean, maintainable code'
    },
    {
      icon: Lightbulb,
      title: 'My Approach',
      description: 'Problem-solving mindset with attention to detail'
    },
    {
      icon: TrendingUp,
      title: 'My Goal',
      description: 'Continuous learning and real-world application'
    }
  ];

  return (
    <section id="about" className="py-20 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">
            About <span className="bg-gradient-to-r from-blue-500 to-cyan-500 bg-clip-text text-transparent">Me</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full"></div>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-start mb-16">
          {/* Left: Text Content */}
          <div className="space-y-6">
            <p className="text-gray-300 text-lg leading-relaxed">
              {aboutContent.intro}
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              {aboutContent.mission}
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              {aboutContent.approach}
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              {aboutContent.goal}
            </p>
          </div>

          {/* Right: Highlight Cards */}
          <div className="grid sm:grid-cols-2 gap-6">
            {highlights.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <Card
                  key={index}
                  className="bg-[#1a1a1b] border-gray-800 hover:border-blue-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/10 group"
                >
                  <CardContent className="p-6">
                    <div className="mb-4">
                      <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-600 to-cyan-600 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <IconComponent size={24} className="text-white" />
                      </div>
                    </div>
                    <h3 className="text-xl font-semibold mb-2 text-white group-hover:text-blue-400 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
